export default __webpack_public_path__ + "static/media/12.118043f1.png";